import { QueryClient } from '@tanstack/react-query';

// React Query 클라이언트 singleton
// 로그아웃 등 비-React 컨텍스트(MST 액션 등)에서 캐시 초기화에 사용
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: false,
    },
  },
});
